module.exports = __webpack_public_path__ + "img/228-nauru.01177691.svg";